import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from './slice/authSlice';
import tickerReducer from './slice/tickerSlice';
import watchlistReducer from './slice/watchlistSlice';
import workbenchReducer from './slice/workbenchSlice';
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from 'redux-persist';


const rootReducer = combineReducers({
  auth: authReducer,
  ticker: tickerReducer,
  watchlist: watchlistReducer,
  workbench: workbenchReducer,
});

const persistConfig = {
  key: "root",
  storage, // Use the imported storage engine
  whitelist: ["auth"], // Specify the slices you want to persist
};

const persistedReducer = persistReducer(persistConfig, rootReducer);


const store = configureStore({
  reducer: persistedReducer, // Use the persisted reducer
});

const persistor = persistStore(store);
export { store, persistor };
